// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  display: grid;
  grid-template-rows: auto 1fr auto;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: rgba(0,0,0,0.06);
  font-family: Helvetica, Arial, sans-serif;
}

.skip-link {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
}

.skip-link:focus {
  position: absolute;
  left: 0;
  top: 0;
  width: auto;
  height: auto;
  padding: 10px 20px;
  text-decoration: none;
  background-color: white;
  color: black;
  z-index: 100;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px;
  min-height: 50vh;
  font-family: "aktiv-grotesk-std", Arial, sans-serif;
  font-weight: 300;
  text-rendering: optimizeLegibility;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":["body {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n  background-color: rgba(0,0,0,0.06);\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n.skip-link {\n  position: absolute;\n  left: -9999px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n}\n\n.skip-link:focus {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: auto;\n  height: auto;\n  padding: 10px 20px;\n  text-decoration: none;\n  background-color: white;\n  color: black;\n  z-index: 100;\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 35px;\n  min-height: 50vh;\n  font-family: \"aktiv-grotesk-std\", Arial, sans-serif;\n  font-weight: 300;\n  text-rendering: optimizeLegibility;\n}\n\n@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
